import React from 'react'
import { SiteHeader } from '../../components/site-header'
import { motion } from 'framer-motion'
import { SurveyCreator } from '../../components/survey/creation/survey-creator'
import { Card, CardContent } from '../../components/ui/card'
import { Button } from '../../components/ui/button'
import { Mail } from 'lucide-react'
import { supabase } from '../../lib/supabase'
import { toast } from 'sonner'

export default function SurveyManagePage() {
  const [emailConfirmed, setEmailConfirmed] = React.useState<boolean | null>(null)
  const [email, setEmail] = React.useState<string | null>(null)

  React.useEffect(() => {
    const checkEmailConfirmation = async () => {
      const { data: { user } } = await supabase.auth.getUser()
      if (user) {
        setEmailConfirmed(user.email_confirmed_at !== null)
        setEmail(user.email || null)
      }
    }
    checkEmailConfirmation()
  }, [])

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <div className="absolute inset-0 z-0 bg-background">
          <div className="relative w-full h-full">
            <img
              src="/images/backgrounds/flickr-21903280519.jpg"
              alt="Survey background"
              className="object-cover hero-bg w-full h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/70 to-background" />
          </div>
        </div>
        
        <section className="container relative z-10 py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-3xl mx-auto text-center space-y-6"
          >
            <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
              Manage Surveys
            </h1>
            <p className="text-xl text-muted-foreground">
              Create and manage your SLK Profile™ surveys
            </p>
          </motion.div>

          {emailConfirmed === false && (
            <div className="mt-8 max-w-2xl mx-auto">
              <Card>
                <CardContent className="p-6">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                      <Mail className="w-6 h-6 text-primary" />
                    </div>
                    <div className="flex-1 space-y-2">
                      <h2 className="text-lg font-semibold">Please Confirm Your Email</h2>
                      <p className="text-muted-foreground">
                        We've sent a confirmation link to <span className="font-medium">{email}</span>. 
                        Please check your email and click the link to access survey management.
                      </p>
                      <Button 
                        variant="outline"
                        onClick={async () => {
                          const { error } = await supabase.auth.resend({
                            type: 'signup',
                            email: email || '',
                          })
                          if (!error) {
                            toast.success('Confirmation email resent')
                          }
                        }}
                      >
                        Resend Confirmation Email
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          )}

          <div className="mt-8 max-w-4xl mx-auto">
            {emailConfirmed === true && <SurveyCreator />}
          </div>
        </section>
      </main>
    </div>
  )
}